<div class="card-inner-main-div">
  <div class="card-main-title border-bottom">
    <h4 class="card-title">{{ 'Task' | translate }} <span class="small-light-text d-block">{{ 'Contribution to exposures for This Task Group' | translate }}</span></h4>
  </div>
  <div class="tableColStyle without-borders-table mt-3">
    @if (loadingExposureByTaskGroup) {
      <div class="comments-loader">
        <img src="assets/images/loader.gif">
      </div>
    }
    @if (!loadingExposureByTaskGroup) {
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">
                <a>{{ 'Task' | translate }}</a>
              </th>
              <th scope="col">
                <a>{{ 'Time on Shift %' | translate }}</a>
              </th>
              <th scope="col">
                <a>{{ 'Mass Contribution %' | translate }}</a>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (exposure of exposureByTaskGroupName; track trackByIndex($index)) {
              <tr [ngClass]="{active: 0}"
                (click)="toggleTaskPopupFn(exposure)">
                <td><a>{{exposure?.taskName}}</a></td>
                <td><a>
                  <div class="percentage-txt-div justify-content-between w-100">
                    <span class="percent-box sky-blue-bg"
                    [style]="{width: exposure?.timeOnShiftPercentAbs+'%'}"></span>{{exposure?.timeOnShiftPercent}}%
                  </div>
                </a></td>
                <td><a>
                  <div class="percentage-txt-div justify-content-between w-100">
                    <span class="percent-box purple-bg"
                    [style]="{width: exposure?.massContributionPercentAbs+'%'}"></span>{{exposure?.massContributionPercent}}%
                  </div>
                </a></td>
              </tr>
            }
            @if (exposureByTaskGroupName && !exposureByTaskGroupName.length) {
              <tr>
                <td colspan="3" class="no-data-available with-padding">{{errorMessage}}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>